import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export default makeStyles(
  (theme) => ({
    root: {
      width: '100%',
      maxWidth: 545,
      padding: theme.spacing(5.5, 0, 2),
    },
    dialogTitle: {
      padding: theme.spacing(0, 4.5),
    },
    buttonClose: {
      top: '20px',
      right: '20px',
    },
    title: {
      fontSize: theme.typography.pxToRem(20),
      lineHeight: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightMedium,
    },
    subtitle: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(18),
      color: COLORS.neutral.mediumGray,
      marginBottom: theme.spacing(2),
    },
    dialogContent: {
      padding: theme.spacing(4, 4.5),
    },
    dialogContentWithSubtitle: {
      paddingTop: theme.spacing(0.75),
    },
    field: {
      width: '100%',
    },
    dialogActions: {
      borderTop: `1px solid ${COLORS.primary.light}`,
      padding: theme.spacing(2, 4.5, 0),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      margin: 0,
    },
    buttonCancel: {
      minWidth: 'unset',
      padding: 0,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightMedium,

      '&:hover': {
        backgroundColor: theme.palette.common.white,
        textDecoration: 'underline',
      },
    },
    buttonSubmit: {
      height: 40,
      minWidth: 153,
      padding: theme.spacing(1, 3),
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightMedium,

      '&&': {
        marginLeft: theme.spacing(3),
      },
    },
  }),
  { name: 'PopupWithInputField' }
);
